module.exports = __webpack_public_path__ + "static/media/sitemap2.eeff99a4.svg";